const limitText = (text = "", limit = 100, shoudTransform = true) => {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    return (temp.textContent || temp.innerText || "").substr(0, limit);
}

export {
    limitText
}